import React from "react";
import Slider from "react-slick";
import { dataTop } from "../../DUMMYDATA/DUMMYDATA";
// import LeftArrow from "../../../assets/left-arrow.svg";
// import RightArrow from "../../../assets/right-arrow.svg";
import { Link } from "react-router-dom";
import { HiMiniArrowLongLeft } from "react-icons/hi2";
import { HiMiniArrowLongRight } from "react-icons/hi2";

const HomeSlider = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className="absolute z-10 left-0 top-1/2 transform -translate-y-1/2 -ml-5 text-3xl text-black hover:text-red-500 transition-all"
    >
      <HiMiniArrowLongLeft className="text-tertary2" />
    </button>
  );

  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className="absolute z-10 right-0 top-1/2 transform -translate-y-1/2 -mr-5 text-3xl text-black hover:text-red-500 transition-all"
    >
      <HiMiniArrowLongRight className="text-tertary2" />
    </button>
  );

  // const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
  //   <button
  //     {...props}
  //     className="absolute z-10 left-0 top-1/2 transform -translate-y-1/2 text-3xl text-black hover:text-red-500 transition-all"
  //   >
  //     <HiMiniArrowLongLeft className="text-tertary2" />
  //   </button>
  // );

  // const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
  //   <button
  //     {...props}
  //     className="absolute z-10 right-0 top-1/2 transform -translate-y-1/2 mr-[-40px] text-3xl text-black hover:text-red-500 transition-all"
  //   >
  //     <HiMiniArrowLongRight className="text-tertary2" />
  //   </button>
  // );

  const settings = {
    // autoplay : true,
    loop: true,
    // dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="lg:w-[89%] max-sm:w-[80%] md:w-[80%] max-md:w-[80%] my-[10.25rem] max-sm:mb-[2.25rem] lg:mb-28 md:mb-20 sm:mb-11 mx-auto -mt-12 text-center">
      <h1 className="mt-[93px] mb-[88px] text-3xl font-bold max-sm:text-[19px]  max-sm:mt-[60px] max-sm:mb-[58px] text-tertary2">
        DISCOVER THE CATEGORIES
      </h1>
      <Slider {...settings} className="mx-auto">
        {dataTop.map((item) => {
          return (
            <div className="px-4" key={item.title}>
              <Link
                to={`/category-detail/${item.title.toLowerCase()}`}
                onClick={scrollToTop}
              >
                <img src={item.url} alt="slider_img" className="mx-auto" />
                <p className="text-black text-lg font-bold pt-4">
                  {item.title}
                </p>
              </Link>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default HomeSlider;
